import {useContext, useEffect} from "react";
import {AuthContext} from "../Contexts/AuthProvider";

function LandingOut({children}) {
    const {isDarkMode} = useContext(AuthContext); // Access the user context to get credits

    useEffect(() => {
        const metaThemeColor = document.querySelector('meta[name="theme-color"]');
        metaThemeColor.setAttribute("content", "#000");
    });


    return (<>
            <style>{`
::-webkit-scrollbar-track {
  background: #000000;
}
::-webkit-scrollbar-thumb {
  background: #697089;
}
::-webkit-scrollbar-thumb:hover {
  background: #697089;
}
        `}
            </style>
            <div className={`min-h-screen bg-black  `}>
                {children}
            </div>
        </>
    );
}

export default LandingOut;
